import { render, staticRenderFns } from "./PanelAccordion.vue?vue&type=template&id=244180ca"
import script from "./PanelAccordion.vue?vue&type=script&lang=js"
export * from "./PanelAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports